<template>
  <div class="wrapper">
    <div class="form-container">
      <slot name="content">
        <h4>Title</h4>
        <h5 class="secondary-text">Subtitle</h5>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipResult'
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/vars.scss';
@import '~stylesheets/mixins.scss';

.wrapper {
  display: flex;
  flex-direction: column;

  .form-container {
    padding: 23px;
    margin-bottom: 16px;
    text-align: center;
  }

  .result-primary-text {
    font-size: 25px;
    font-weight: bold;
    line-height: 24px;
  }

  .result-success-text {
    color: $notification-green;
  }

  .result-secondary-text {
    color: $dark-gray;
    font-size: 16px;
    line-height: 24px;
  }

  h4 {
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
  }

  h5 {
    font-size: 16px;
    line-height: 24px;
  }

  .secondary-text {
    color: $secondary-elt;
  }
}
</style>
